import ModalAction from '@/utils/modal/ModalAction'
import { ToastListBox } from '@/components/content/Toast'
import { ToastProps } from '@musinsa/mwms-ds'
import { Utils } from '@/utils/Utils'

const TOAST_ID = 'moms-toast'

type MToastActionType = Omit<ToastProps, 'open'>

class MToastAction extends ModalAction<MToastActionType> {
  destroy = (id: string) => {
    const deletedIdx = this.list.findIndex((confirm) => confirm.id === id)
    this.list.splice(deletedIdx, 1)

    if (this.root) {
      this.root.render(<ToastListBox list={this.list} destroy={this.destroy} />)
    }
  }

  show = (content: React.ReactNode, props?: Omit<MToastActionType, 'id' | 'content'>) => {
    this.list.push({ ...props, content, id: Utils.uuid() })

    if (this.root) {
      this.root.render(<ToastListBox list={this.list} destroy={this.destroy} />)
    }
  }

  error = (content: React.ReactNode, props?: Omit<MToastActionType, 'id' | 'content'>) => {
    this.list.push({ ...props, content, id: Utils.uuid(), kind: 'error' })

    if (this.root) {
      this.root.render(<ToastListBox list={this.list} destroy={this.destroy} />)
    }
  }
}

const MToast = new MToastAction(TOAST_ID)
export default MToast
